import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

export default function UnsavedChangesModal({
  show,
  onCancel,
  onDiscard,
  onSaveAndExit
}) {
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Unsaved Changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        You have unsaved changes in your accounting settings. Do you want to save them before leaving?
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDiscard}>
          Discard Changes
        </Button>
        <Button variant="primary" onClick={onSaveAndExit}>
          Save & Exit
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
